import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import PageContent from '@/lib/components/common/PageContent.tsx';
import { AnalyticsProvider } from './components/providers/AnalyticsProvider.tsx';
import I18nProvider from './components/providers/I18nProvider.tsx';
import ReduxProvider from './components/providers/ReduxProvider.tsx';
import { NotificationsPortal, NotificationsProvider } from './hooks/useNotify.tsx';
import APIErrorProvider from './components/providers/APIErrorProvider.tsx';
import { AuthProvider } from './components/providers/AuthProvider/AuthProvider.tsx';
import ResourceActionsProvider from './components/providers/ResourceActionProvider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AnalyticsProvider>
      <I18nProvider>
        <ReduxProvider>
          <BrowserRouter>
            <AuthProvider>
              <NotificationsProvider>
                <APIErrorProvider>
                  <NotificationsPortal />
                  <ResourceActionsProvider />
                  <PageContent>
                    <App />
                  </PageContent>
                </APIErrorProvider>
              </NotificationsProvider>
            </AuthProvider>
          </BrowserRouter>
        </ReduxProvider>
      </I18nProvider>
    </AnalyticsProvider>
  </StrictMode>,
);
